import { Length } from 'class-validator';

export class OrangeStripeSectionUpdateModel {
  @Length(2, 255)
  public text: string;

  @Length(2, 255)
  public link: string;
}
